import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * HVAC Icon Style 01 - AC Unit (Material Symbol)
 * - isOn = true: 青色實心冷氣 (FILL: 1)
 * - isOn = false: 灰色空心冷氣 (FILL: 0)
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:ac_unit
 */
export const Style01_AcUnit: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-cyan-500' : 'text-slate-400';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      ac_unit
    </span>
  );
};

export default Style01_AcUnit;
